module.exports = __webpack_public_path__ + "static/img/world1.a6d34982.png";